import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { Button } from "react-bootstrap";
import { errorMessage } from "../../utils/alertMessage";
import { searchRFIDTag } from "../../services/RFID/Rfid";
import { Checkbox } from "primereact/checkbox";
import { orderInfoBasedOnQrCode } from "../../services/OrdersAPI/Orders";

const CheckGarmentRFID = () => {
  const location = useLocation();
  const { bookingOrderId, storeCustomerId, navThrough } = location.state || {}; // Fallback to prevent undefined errors

  const { brandProfileData, storeData, userProfileData } = getUserData();

  let userRole = userProfileData;
  let brandId = brandProfileData.id;
  let storeId = storeData.id;

  const navigate = useNavigate();
  const [rfidInput, setRfidInput] = useState(""); // current scanned input
  const [rfidMultipleInput, setRfidMultipleInput] = useState(""); // current scanned input
  const [scannedRFID, setScannedRFID] = useState([]); // all scanned RFIDs
  const [apiResponse, setApiResponse] = useState([]); // API response data
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(false);
  const [apiResMessage, setApiResMessage] = useState("");
  const [checkedSingleScan, setCheckedSingleScan] = useState(true);
  const [checkedMultiScan, setCheckedMultiScan] = useState(false);
  const [garmentInfo, setGarmentInfo] = useState([])

  // ✅ Function to call the API when a valid RFID (24 chars) is scanned
  const fetchQrCodeInfo = (rfid) => {
    setLoading(true);
    const data = {
      brandIdIn: [brandId],
      storeIdIn: [storeId],
      searchType: "mapped",
      rfIdIn: [rfid],
    };

    searchRFIDTag(data)
      .then((response) => {
        setLoading(false);
        if (!response.data.error) {
          const resData = response.data;
          setApiResponse(resData);
          setApiResStatus(true);
          setApiResMessage("RFID Is Scanned");
          setModalVisible(true);
        } else {
          setApiResStatus(false);
          setApiResMessage(response.data.message || "Error fetching RFID info");
          setModalVisible(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error:", err);
        errorMessage("Something went wrong while fetching RFID info");
      });
  };

  // ✅ Watch input and trigger scan once 24 characters entered
  useEffect(() => {
    if (rfidInput.length === 24) {
      if (!scannedRFID.includes(rfidInput)) {
        setScannedRFID((prev) => [...prev, rfidInput]);
        fetchQrCodeInfo(rfidInput);
      } else {
        errorMessage("This RFID has already been scanned!");
      }
      setRfidInput(""); // clear input for next scan
    }
  }, [rfidInput]);

  useEffect(() => {
    if (rfidMultipleInput.length === 24) {
      if (!scannedRFID.includes(rfidMultipleInput)) {
        setScannedRFID((prev) => [...prev, rfidMultipleInput]);
      } else {
        errorMessage("This RFID has already been scanned!");
      }
      setRfidMultipleInput(""); // clear input for next scan
    }
  }, [rfidMultipleInput]);

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const fetchMoreInfo = (id) => {
    orderInfoBasedOnQrCode(id)
      .then((response) => {
        if (!response.data.error) {
          const resData = response.data;
          setGarmentInfo(resData);
        } else {
          errorMessage(response.data.message || "Error fetching RFID info");
          
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        errorMessage("Something went wrong while fetching RFID info");
      });
  }

   const handleConfirmAndContinue = () => {
      // Use the selectedQrCodeItems array for further processing
      if (!isSubmitButtonPressed) {

      // Enable submit button / proceed
    setIsSubmitButtonPressed(true);

    const data = {
      brandIdIn: [brandId],
      storeIdIn: [storeId],
      searchType: "mapped",
      rfIdIn: scannedRFID,
    };

    searchRFIDTag(data)
      .then((response) => {
        if (!response.data.error) {
          const resData = response.data;
          setApiResponse(resData);
          setApiResStatus(true);
          setApiResMessage("RFID Is Mapped");
          setModalVisible(true);
          setIsSubmitButtonPressed(false);
        } else {
          setApiResStatus(false);
          setApiResMessage(response.data.message || "Error fetching RFID info");
          setModalVisible(true);
          setIsSubmitButtonPressed(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        errorMessage("Something went wrong while fetching RFID info");
      });
  }};


  const renderTagInfoItem = () => {
    return apiResponse?.map((item, index) => {
      return (
        <div key={item.id} className="border-bottom-1 mx-3 px-3">
          <div className="flex flex-column">
            <div className="flex justify-content-between align-items-center">
              <p className="flex justify-content-center align-items-center text-lg font-medium">
                {item.qrcode} - {item.rfid}
              </p>
              <button
                onClick={() => fetchMoreInfo(item.id)}
                className="p-button p-button-primary p-button-sm mx-5 my-1"
                style={{
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "4px 10px",
                  cursor: "pointer",
                }}
              >
                Get More Info
              </button>
            </div>
            <div className="flex justify-content-between align-items-center">
              {garmentInfo.id === item.orderItemId && (
                <div className="flex flex-row text-center">
                  <p className="flex justify-content-center align-items-center text-md font-medium text-center">
                    {garmentInfo?.order?.customerName + " | "}
                  </p>
                  <p className="flex justify-content-center align-items-center text-md font-medium mx-2 text-center">
                    {garmentInfo?.order?.customerMobile + " | "}
                  </p>
                  <p className="flex justify-content-center align-items-center text-md font-medium mx-2 text-center">
                    {garmentInfo?.garmentAlias !== ""
                      ? garmentInfo?.garmentAlias + " | "
                      : garmentInfo?.garmentName + " | "}
                  </p>
                  <p className="flex justify-content-center align-items-center text-md font-medium mx-2 text-center">
                    {garmentInfo?.garmentService + " | "}
                  </p>
                  <p className="flex justify-content-center align-items-center text-md font-medium mx-2 text-center">
                    {garmentInfo?.order?.status}
                  </p>
                  <button
                    onClick={() =>
                      navigate("/OrdersGarmentInfo", {
                        state: {
                          bookingOrderId: garmentInfo?.order?.id,
                          storeCustomerId: garmentInfo?.order?.storeCustomerId,
                          navigateThrough: "GoBack",
                        },
                      })
                    }
                    className="p-button p-button-success p-button-sm  my-1"
                    style={{
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      padding: "4px 10px",
                      cursor: "pointer",
                    }}
                  >
                    Open Bill
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    navThrough === "customerOrder"
                      ? navigate("/OrdersGarmentInfo", {
                          state: {
                            bookingOrderId: bookingOrderId,
                            storeCustomerId: storeCustomerId,
                          },
                        })
                      : navigate(-1);
                  }}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Checked RFID Mapped With Garment
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1 flex mx-4 gap-4 mt-2">
        <div
          className="border-round-lg shadow-2 flex flex-1 px-3 py-2 justify-content-between"
          style={{
            backgroundColor: "#fff",
          }}
        >
          <p
            className=" text-md font-normal capitalize"
            style={{ color: "#6b7280" }}
          >
            Single Scan
          </p>
          <Checkbox
            checked={checkedSingleScan}
            onChange={() => {
              setCheckedSingleScan(true);
              setCheckedMultiScan(false);
            }}
          ></Checkbox>
        </div>

        <div
          className="border-round-lg shadow-2 flex flex-1 px-3 py-2 justify-content-between"
          style={{
            backgroundColor: "#fff",
          }}
        >
          <p
            className=" text-md font-normal capitalize"
            style={{ color: "#6b7280" }}
          >
            Multi Scan
          </p>
          <Checkbox
            checked={checkedMultiScan}
            onChange={() => {
              setCheckedMultiScan(true);
              setCheckedSingleScan(false);
            }}
          ></Checkbox>
        </div>
      </div>
      {/* Content */}
      {checkedSingleScan && (
        <div className="px-4 py-2 bg-white">
          <h5>Scan RFID Tag</h5>
          <InputText
            autoFocus
            placeholder="Scan RFID here..."
            value={rfidInput}
            onChange={(e) => setRfidInput(e.target.value.trim())}
            style={{ width: "100%", fontSize: "18px" }}
          />

          {/* Show scanned list */}
          {/*scannedRFID.length > 0 && (
            <div className="mt-3">
              <h6>Scanned RFIDs:</h6>
              <ul>
                {scannedRFID.map((tag, index) => (
                  <li key={index}>{tag}</li>
                ))}
              </ul>
            </div>
          )*/}
        </div>
      )}
      {checkedMultiScan && (
        <div className="px-4 pt-2 bg-white">
          <p className="text-lg font-bold">Scan RFID Tag</p>
          <InputText
            autoFocus
            placeholder="Scan RFID here..."
            value={rfidMultipleInput}
            onChange={(e) => setRfidMultipleInput(e.target.value.trim())}
            style={{ width: "100%", fontSize: "18px" }}
          />

          {/* Show scanned list */}
          {scannedRFID.length > 0 && (
            <div className="mt-2">
              <p className="text-lg font-bold">Scanned RFIDs:</p>
              <ul>
                {scannedRFID.map((tag, index) => (
                  <li key={index}>{tag}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {/* Show API response */}
      {apiResponse.length > 0 && (
        <div className="mt-2 mx-4">
          <h6>Mapped Garment:</h6>

          {renderTagInfoItem()}
        </div>
      )}

      {checkedMultiScan && (
        <div className="relative mt-8">
          {scannedRFID.length > 0 && (
            <div
              className="flex flex-1 flex-row  py-2 fixed z-2 bottom-0 w-full"
              style={{ backgroundColor: "white" }}
            >
              <div className="flex-1 flex-row mx-4 mb-1 gap-2">
                <Button
                  className="p-2 w-full text-2xl border-1 flex justify-content-center"
                  style={{
                    color: "#fff",
                    backgroundColor: "#2B70D7",
                    borderRadius: 5,
                  }}
                  onClick={() => handleConfirmAndContinue()}
                  disabled={isSubmitButtonPressed}
                >
                  Submit
                </Button>
              </div>
            </div>
          )}
        </div>
      )}

      <div style={{ backgroundColor: "#fff" }}>
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={apiResStatus === true ? "success" : false}
          text={apiResMessage}
        />
      </div>
    </div>
  );
};

export default CheckGarmentRFID;
